<script>
import Gallery from "../common/Gallery.svelte";
import { getWork } from "../../scripts/work";
export let id;
    
</script>
<style>
    .is-200x200{
            width: 200px;
            height: 200px;
        }
    .details {
        color: #363636;
        font-size: 1.2rem;
        line-height: 1.125;
    }
    .details h2 {
        font-size: 1.5rem;
        font-weight: 600;
    }
    .details h3 {
        font-weight: 600;
    }
    ul { margin-bottom: 1rem;}
    h2, h3, li, dd, dt {margin-bottom: .5rem; }
    dd {font-style: italic;}
    .column {
        padding: 1.5rem;
    }
    .magnitude li  {
        display: block;
    }
    .magnitude span {
        display: inline;
    }
    @media(min-width:570px){
        .details li {
            display: flex;
            justify-content: space-between;
        }
        .details li > * {
            display: block;
            width: 50%;
        }
        .magnitude li  {
        display: block;
        }
        .magnitude span {
            display: inline;
        }
        .details li h3:nth-child(1) {
            width: 30%;
        }

    }
    @media(min-width:1000px){
        .columns {
            width:80%;
            margin: auto;
        }
    }
</style>
    
<section class="section">
{#await getWork(id) then work}        
    <h1 class="title has-text-centered">{work.title}</h1>
    <div class="columns">
        <div class="column is-half">
            <Gallery images={work.images}/>
         </div>
        <div class="column is-half details">
            <h2>Location:</h2>
            <ul>
                <li><h3>Name:</h3> <p>{work.locationName}</p></li>
                <li>
                    <h3>Map:</h3>
                    <div>
                        <figure class="image is-200x200">
                            <picture>
                                <source srcset="{work.mapUrl()} 1x, {work.mapUrl(true)} 2x" type="image/jpeg">
                                <img class="image" src="{work.mapUrl()}" alt="Map">
                            </picture>
                        </figure>
                    </div>
                </li>
                <li>
                    <h3>Coordinates:</h3> 
                    <div class="coordinates">
                        <span class="longitude">{work.longitude.toFixed(4)}</span>,
                        <span class="latitude">{work.latitude.toFixed(4)}</span>
                    </div>
                </li>
            </ul>
            <h2>Date:</h2>
            <ul>
                <li><h3>Sub-Atomic:</h3><p>{work.subAtomicDate}</p></li>
                <li><h3>Gregorian:</h3><p>{work.date}</p></li>
            </ul>
            <h2>Specs:</h2>
            <ul>
            <li><h3>Material:</h3> 
                <ul>
                    <dl>
                           {#each work.materials as material}
                           <dl>
                               <dt>{material.name}</dt>
                               <dd>{material.description}</dd>
                           </dl>
                           {/each} 
                    </dl>
                </ul>
            </li>
            <li><h3>Dimensions:</h3> 
                <ul>
                    <ul>
                           {#each work.dimensions as dimension}
                                <li>
                                    <h4>{dimension.name}:</h4>
                                    <ul class="magnitude">
                                        {#each dimension.value as value}
                                                <li>{value.magnitude}<span class="unit">{value.unit}</span></li>
                                        {/each}
                                    </ul>
                                </li>
                           {/each} 
                    </ul>
                </ul>
            </li>
            </ul>
        </div>

    </div>
{/await}
</section>
